import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterProductsList'
})
export class FilterPipeProduct implements PipeTransform {
    transform(products: any, term?: any): any {
        if (term === undefined) return products;
        if (term === null) return products;

        if (products != null) {
            return products.filter(function (product) {
                if (product.name != undefined)
                    if (product.name.toLowerCase().includes(term.toLowerCase()))
                        return product;
                if (product.tags_static != undefined)
                    if (product.tags_static.toString().toLowerCase().includes(term.toLowerCase()))
                        return product;
                if (product.tags != undefined)
                    if (product.tags.toString().toLowerCase().includes(term.toLowerCase()))
                        return product;
                if (product.price_static == term)
                    return product;
                if (product.stock != undefined)
                    if (product.stock.toString().toLowerCase().includes(term.toLowerCase()))
                        return product;
                if (product.stock_alert != undefined)
                    if (product.stock_alert.toString().toLowerCase().includes(term.toLowerCase()))
                        return product;
            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/products/filter.pipe.ts